import React, { PropTypes } from 'react'

import PaintSwatch from 'components/PaintSwatch'
import classNames from 'classnames'

const PaintFillSummary = ({ paints, header, labelOverride }) => (
  <div className="customize-form-section">
    {header && 
      <div className="customize-form-section-header">{header}</div>
    }
      <div className="customize-form-section-content">
        {
          paints.map((paint) => (
            <div key={paint.loc.id} className={classNames("paintfill-chooser", { "error" : !paint.valid })}>
              <div className="paintfill-selection">
                <span className="paintfill-selection-text">
                {labelOverride &&
                  paint.loc.label.replace('Line', labelOverride)
                }
                {!labelOverride &&
                  paint.loc.label
                }
                </span>
                <PaintSwatch paint={paint.selected} />
              </div>
            </div>
          ))
        }
      </div>  
  </div>
)

PaintFillSummary.propTypes = {
  paints: PropTypes.arrayOf(PropTypes.object).isRequired,
  labelOverride: PropTypes.string,
}

export default PaintFillSummary